import { Box, Tooltip, Typography, useTheme } from "@mui/material";
import { roundMacros } from "@notemeal/shared-utils-macro-protocol";
import { MenuBuilderMenuItemWithMacrosFragment } from "apps/web/src/types";
import { getServingAmountsMacros } from "shared-ui/ServingAmount/utils";
import { MenuBuilderMenuItemMacro } from "./MenuBuilderMenuItemMacro";

const MenuItemOption = ({ option }: { option: MenuBuilderMenuItemWithMacrosFragment["choices"][number]["options"][number] }) => {
  const theme = useTheme();

  return (
    <Box sx={{ my: 1, display: "flex", flexDirection: "column", gap: 0 }}>
      <Typography variant="subtitle1Medium" sx={{ color: theme.palette.mediumEmphasisTextDark }}>
        {option.name}
      </Typography>
      {option.servingAmounts && (
        <Box>
          <MenuBuilderMenuItemMacro
            macros={roundMacros(getServingAmountsMacros(option.servingAmounts))}
            fontColor={theme.palette.mediumEmphasisTextDark}
            variant="subtitle1Medium"
          />
        </Box>
      )}
    </Box>
  );
};

export const MenuItemMacrosBreakdownTooltip = ({ menuItem }: { menuItem: MenuBuilderMenuItemWithMacrosFragment }) => (
  <Tooltip
    title={
      <Box
        sx={{
          p: 1,
          borderRadius: 1,
          overflow: "auto",
        }}
      >
        <Typography variant="subtitle1Semibold" sx={{ color: "inherit" }}>
          Add-ons for {menuItem.name}
        </Typography>
        {menuItem.choices?.map(choice => (
          <Box key={choice.id} sx={{ mb: 2 }}>
            <Typography variant="subtitle1Medium" sx={{ fontWeight: "bold", mb: 2, color: "inherit" }}>
              {choice.name}
            </Typography>
            {choice.options.map((option: MenuBuilderMenuItemWithMacrosFragment["choices"][number]["options"][number]) => (
              <MenuItemOption key={option.id} option={option} />
            ))}
          </Box>
        ))}
      </Box>
    }
    placement="right-start"
  >
    <Box
      sx={theme => ({
        borderRadius: 4,
        bgcolor: theme.palette.greyscale[100],
        height: 16,
        width: 61,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      })}
    >
      <Typography variant="footnotes">+ Add-ons</Typography>
    </Box>
  </Tooltip>
);
